import { render, staticRenderFns } from "./FollowUpEditor.vue?vue&type=template&id=119c90ab&"
import script from "./FollowUpEditor.vue?vue&type=script&lang=tsx&"
export * from "./FollowUpEditor.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports